<style lang="less">
  @import "./ParkingList.less";
</style>

<template>
  <div class="parking-list">
     <van-swipe :autoplay="3000" :style="{'height': bannerHeight + 'px'}" indicator-color="#02aeff">
        <van-swipe-item v-for="(image, index) in adList" :key="index" @click="toAdLinkFn(image.to, image.url)">
          <img :alt="image.title || '欢迎您'" v-lazy="image.img_url" />
        </van-swipe-item>
      </van-swipe>

    <!--总次数-->
    <!-- <div class="parking-list-total" v-if="photoList && photoList.length>0">
      您共有 <span>{{countNumber}}</span> 条停车报告记录！
    </div> -->

    <!--<div class="parking-list-top" v-if="photoList && photoList.length>0">-->
      <!--<h3>停车报告</h3>-->
      <!--&lt;!&ndash;<span>编辑</span>&ndash;&gt;-->
    <!--</div>-->

    <!--没有数据-->
    <div class="no-data" v-if="!(photoList && photoList.length>0)">
      <img alt="" src="../../../assets/images/ic_no_data.png">
      <p>您还没有停车报告哦~</p>
    </div>

    <div>
      <!--加载-->
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="photoList && photoList.length>0 ? '没有更多数据了' : ''"
        :offset="30"
        @load="onLoad"
      >

        <div>
          <div class="parking-list-con clear" v-for="(groupItem, groupIndex) in photoList" :key="groupIndex">
            <h4 class="">
              {{groupItem.finishTimeShow}}
            </h4>
            <div v-for="item in groupItem.children" :key="item._id" @click="toParkingPositionPageFn(item)">
              <div class="flex-wrap">
                <img :src="item.url_thumb" class="thumb" alt="" >
                <div>
                  <div class="location" v-if="item.auth_travel_manage===2">行程管理权限未开启</div>
                  <template>
                    <p v-if="(!item.location)" @click.stop="transformHandle(item._id,item.type)"><i style="color: #007BFE;">点击查看详细地址</i></p>
                    <div v-else class="location">{{item.location}}</div>
                  </template>
                  <p class="deleteAndTime"><label>{{item.startToEnd}}</label> <img src="../../../assets/images/delete.png" @click.stop="deleteParkingReport(item)" class="delBtn"></img></p>
                </div>
              </div>
              <!-- <div class="clear" v-if="item.auth_travel_manage!==2"><span>查看详情 <van-icon name="arrow" size="1rem" /></span></div> -->
            </div>
          </div>
        </div>
      </van-list>
    </div>

  </div>
</template>

<script>
import Demo from './ParkingList.js'
export default {
  ...Demo
}
</script>
